document.addEventListener('DOMContentLoaded', (): void => {
  const accordionButtons: NodeListOf<HTMLButtonElement> =
    document.querySelectorAll('.accordion-button');

  accordionButtons.forEach((button: HTMLButtonElement): void => {
    button.addEventListener(
      'click',
      function handleClick(this: HTMLButtonElement): void {
        // ボタンの状態を切り替え
        this.classList.toggle('is-open');

        // アコーディオンコンテンツを取得して開閉
        const content = this.nextElementSibling as HTMLDivElement;
        if (content) {
          content.classList.toggle('is-open');
        }
      }
    );
  });
});
